import { render, staticRenderFns } from "./BaseSidebarItem.vue?vue&type=template&id=3b082fcd&functional=true&"
import script from "./BaseSidebarItem.vue?vue&type=script&lang=js&"
export * from "./BaseSidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseSidebarItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports